import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {SaleInvoiceSummaryModel} from '../saleInvoiceSummary.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {DocumentSummaryConverter} from '../../../../../../document/common/api/converter/DocumentSummary.converter';
import {EntityWithAuditMetadataConverter} from '../../../../../../common/converter/entityWithAuditMetadata.converter';
import {Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceSummaryConverter extends HttpModelConverter<SaleInvoiceSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter,
                private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter) {
        super();
    }
    protected createInstance(): SaleInvoiceSummaryModel {
        return new SaleInvoiceSummaryModel();
    }

    protected enrichObject(result: SaleInvoiceSummaryModel, src: SaleInvoiceSummaryModel) {
        result.status = this.lovValueSummaryConverter.convert(src.status);
        result.document = this.documentSummaryConverter.convert(src.document);
        this.entityWithAuditMetadataConverter.convert(result, src);
    }


}
